// 校区/楼宇/房间 联动下拉(数据源 api/training/room/building/list 的校区树)
//
// 用法:mixins: [mixinBuilding]
//   页面表单对象里保留 school_area / building_name / room_name 三个字段(对象名任意,如 formInline/ruleForm):
//     校区:  v-for="item in buildingTree"                        + @change="handleLinkageChange('formInline', 'area')"
//     楼宇:  v-for="item in buildingOptionsOf('formInline')"      + @change="handleLinkageChange('formInline', 'building')"
//     房间号: v-for="item in roomOptionsOf('formInline')"
//
// 树第一级是校区、第二级是楼宇;楼宇的下一级若还带 children 说明是四级树,
// 房间号取"楼层名+房间名"(如 1楼101室),否则该级名称本身就是房间号
export let mixinBuilding = {
  data() {
    return {
      buildingTree: [],
    };
  },
  created() {
    this.getBuildingTree();
  },
  methods: {
    // 校区/楼宇/房间树(接口是分页结构,取 data.data)
    async getBuildingTree() {
      let res = await this.$api.instance.interfaceServer('api/training/room/building/list', 'get', { page: 1, size: 999 });
      if (res.code == 0 && res.data) {
        this.buildingTree = res.data.data || [];
      }
    },
    // 指定校区下的楼宇(树第二级)
    findBuildings(areaName) {
      let area = (this.buildingTree || []).find(item => item.name === areaName);
      return (area && area.children) || [];
    },
    // 指定楼宇下的房间号选项
    buildRoomOptions(areaName, buildingName) {
      let building = this.findBuildings(areaName).find(item => item.name === buildingName);
      let list = [];
      ((building && building.children) || []).forEach(node => {
        if (node.children && node.children.length) {
          node.children.forEach(room => list.push({ id: room.id, name: `${node.name}${room.name}` }));
        } else {
          list.push({ id: node.id, name: node.name });
        }
      });
      return list;
    },
    // 表单对象名 → 楼宇选项
    buildingOptionsOf(formKey) {
      return this.findBuildings((this[formKey] || {}).school_area);
    },
    // 表单对象名 → 房间号选项
    roomOptionsOf(formKey) {
      let form = this[formKey] || {};
      return this.buildRoomOptions(form.school_area, form.building_name);
    },
    // 切校区清空楼宇+房间,切楼宇清空房间
    handleLinkageChange(formKey, level) {
      let form = this[formKey];
      if (!form) return;
      if (level === 'area') form.building_name = '';
      form.room_name = '';
    },
  },
};
